<div class="table-responsive" *ngIf="page">
    <table class="table table-hover">
        <thead>
            <tr>
                <th class="col-minimum" i18n="@@dateLabel">Date</th>
                <th class="col-minimum" i18n="@@orderTaskLabel">Order task</th>
                <th class="col-minimum" i18n="@@costTypeLabel">Cost type</th>
                <th class="col-minimum text-right" i18n="@@articleNumberLabel">Article</th>
                <th class="col-minimum" i18n="@@descriptionLabel">Description</th>
                <th class="col-minimum" i18n="@@approvedByLabel">Approved by</th>
                <th class="col-minimum text-right" i18n="@@quantityLabel">Quantity</th>
                <th class="col-minimum" i18n="@@unitLabel">Unit</th>
                <th class="col-minimum text-right" i18n="@@priceLabel">Price</th>
                <th class="col-minimum text-right" i18n="@@totalLabel">Total</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let entity of page.entities">
                <td>{{entity.fiscalDateDays | fiscalDate | xenaDate}}</td>
                <td>{{entity.orderTaskAbbreviation}}</td>
                <td>{{entity.costTypeDescription}}</td>
                <td class="text-right">{{entity.articleNumber}}</td>
                <td>{{entity.description}}</td>
                <td>
                  <span *ngIf="getApprovedNames(entity).length==1" >{{getApprovedNames(entity)[0]}}</span>
                  <xena-tooltip [content]="approvedNamesTooltip(entity)" *ngIf="getApprovedNames(entity).length > 1">
                    <span>{{getApprovedNames(entity)[0]}} +{{getApprovedNames(entity).length-1}}</span>
                  </xena-tooltip>
                </td>
                <td class="text-right">{{entity.quantity | fixedNumber}}</td>
                <td>{{entity.unitAbbreviation}}</td>
                <td class="text-right">{{entity.salesPrice | fixedNumber}}</td>
                <td class="text-right">{{entity.total | fixedNumber}}</td>
            </tr>
        </tbody>
    </table>
</div>

<div class="table-footer" *ngIf="totalEntities > 10">
    <xena-pagination
        [page]="pageIndex"
        [totalPages]="pages"
        (pageChange)="pageIndex = $event.detail"
        first-page-tooltip="First Page"
        previous-page-tooltip="Previous Page"
        next-page-tooltip="Next Page"
        last-page-tooltip="Last Page"
        page-label="Page"
        total-pages-label="of"
        i18n-first-page-tooltip="@@paginationFirstPageTooltip"
        i18n-previous-page-tooltip="@@paginationPreviousPageTooltip"
        i18n-next-page-tooltip="@@paginationNextPageTooltip"
        i18n-last-page-tooltip="@@paginationLastPageTooltip"
        i18n-page-label="@@paginationPageLabel"
        i18n-total-pages-label="@@paginationTotalPagesLabel">
    </xena-pagination>
    <xena-page-size class="pull-right" [size]="pageSize" (sizeChange)="pageSize = $event.detail" label="Items per page" i18n-label="@@pageSizeLabel"></xena-page-size>
</div>
